module.exports = __webpack_public_path__ + "static/media/Dreamweaver.8693558d.png";